module.exports = __webpack_public_path__ + "img/group.415c81c5.png";